// extracted by mini-css-extract-plugin
export var button = "collar-info-module--button--thQSw";
export var container = "collar-info-module--container--Hwho+";
export var img = "collar-info-module--img--izP3a";
export var text = "collar-info-module--text--jEqXT";